import React, { useEffect } from "react"
import _ from "lodash"

import { SingleRowCarouselState_s } from "components/table/carousel/carousel-styles"
import { DropdownInput, NamedItemInput, NumberInput } from "components/table/carousel/inputs"
import { field_attrs } from "components/table/lib/column-field"

const InputTypeBasic = (props: {rowData: [], field: string, defaults: {}, persist: Function}) => {

  function updateData(val:any, field:string):void {
    let nextData = _.cloneDeep(props.rowData);
    _.set(nextData, "inputtype", "basic");
    _.set(nextData, "increasedetail", null);

    if (field === 'inflationdetail.inflationNamedItemId'){
      _.set(nextData, 'inflationdetail', {inflationNamedItemId: val, inflationMode: 'namedItem'});
    } else {
      _.set(nextData, field, val);
    }

    if (field === 'amttype' && val !== '/Area/Yr Annually' || field != 'amttype' && nextData['amttype'] != '/Area/Yr Annually'){
      _.set(nextData, 'inflationdetail', null);
    }

    if (!nextData['amttype']) _.set(nextData, 'amttype', props.defaults['increaseType']);
    if (!nextData['effectivemonth']) _.set(nextData, 'effectivemonth', 'Lease Year')
    if (!nextData['inflationdetail'] && nextData['amttype'] === '/Area/Yr Annually') {
      const noneId = _.get(_.find(_.get(props, "namedItems.inflation"), {code: "*None"}), "inflationid")
      _.set(nextData, 'inflationdetail', {'inflationMode': 'namedItem', 'inflationNamedItemId': noneId});
    }

    props.persist(nextData, props.field, props.rowData)
  }

  useEffect(() => {}, [props['rowData']])

  const unnested_attrs = (field) => field_attrs('increase')(field)(props.rowData, props)

  return (
    <div>
      <SingleRowCarouselState_s>
        <div>
          <label>Amt</label>
          <NumberInput className="automated" data={props['rowData']['inputtype'] === 'basic' && props['rowData']} attrs={unnested_attrs} field="amt" readPrecision={4} writePrecision={4} persist={updateData} style={{width: 100}} />
        </div>
        <div>
          <label>Increase Type</label>
          <DropdownInput className="automated increase-type" data={props['rowData']} attrs={unnested_attrs} field="amttype" default={props.defaults['increaseType']} options={['% Increase Annually', '% of Market Annually', '/Area/Yr Annually']} persist={updateData} />
        </div>
        <div>
          <label>Inflation</label>
          <NamedItemInput
            className="automated"
            data={props['rowData']['inputtype'] === 'basic' && props['rowData']}
            attrs={unnested_attrs}
            field="inflationdetail.inflationNamedItemId"
            namedItem="inflationNamedItemId"
            disabled={props['rowData']['amttype'] !== '/Area/Yr Annually'}
            options={_.get(props, "namedItems.inflation")}
            persist={updateData}
          />
        </div>
        <div>
          <label>Effective</label>
          <DropdownInput className="automated" default="Lease Year" data={props['rowData']['inputtype'] === 'basic' && props['rowData']} attrs={unnested_attrs} field="effectivemonth" options={['Calendar Year', 'Lease Year', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']} persist={updateData} />
        </div>
      </SingleRowCarouselState_s>
    </div>
  )
}

export default InputTypeBasic